
export default {
  data() {
    return {
      pool: {},
      activeTitle:'',
      activeKey:'',
      active:[],
      open:false,
      localSearch:''
    };
  },
  async mounted() {
    if (
      process.browser &&
      this.$store.getters.store.eshop.distinctFields &&
      this.$route.query.q
    ) {
      let t = await this.$store.dispatch("distinctFields", {
        q: this.$route.query.q,
      });
      t = (t || []).reduce((acc, p) => {
        if (!acc.key) {
          acc[p.key] = t.filter((f) => f.key == p.key).map((m) => m.value);
        }
        return acc;
      }, {});
      this.pool = t || {};
    }
  },
};
